<template>
  <div 
    class="exercise-card" 
    :class="`card-${exercise.styleType || 'calm'}`" 
    @click="$emit('click')"
    :style="exercise.image_url ? { backgroundImage: `url(${exercise.image_url})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}"
  >
  </div>
</template>

<script>
export default {
  name: 'ExerciseCard',
  props: {
    exercise: {
      type: Object,
      required: true
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.exercise-card {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.exercise-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
}

/* Card variants - fallback backgrounds when no image */
.card-calm {
  background: #f5f5f0;
  color: #4a4a9a;
}

.card-relax {
  background: #f0f0f5;
  color: #5a5a9a;
}

.card-recharge {
  background: #e8eef5;
  color: #4a7ab8;
}

.card-boost {
  background: #1a2744;
  color: #ffffff;
}
</style>
